module.exports = __webpack_public_path__ + "media/src/images/partners/passau-062634db2f86c524c550ce533c4b73f2.jpg";